import React from 'react';
import { withRouter } from 'react-router';

// Local imports
import { ICON_NAMES, TEXT_TYPES } from '../../../utils/Constants';
import * as globalStyles from '../../../utils/GlobalStyles';
import ButtonView from '../../atoms/ButtonView';
import IconView from '../../atoms/IconView';
import LabelView from '../../atoms/LabelView';
import ModalView from '../ModalView';

function ConfirmationModalView(props) {
  const {
    modalPath,
    exitRoute,
    isOpen,
    onClose,
    history,
    onAccept,
    secondaryButtonText = <IconView name={ICON_NAMES.CLOSE} size={16} color={globalStyles.colors.text2} />,
    onSecondaryButton = onClose || (() => history.push(exitRoute)),
    title = 'Are you sure?',
    message,
    children,
    isLoading,
    errorMessage,
    isAcceptDisabled = false,
    isAcceptHidden = false,
    confirmationButtonText = 'Confirm',
    showTitle = true,
    contentContainerStyle,
    isMobile,
    customButtonBackgroundColor,
    centerAcceptButton = false,
    leftTitleIconName = '',
  } = props;

  const dynamicContainerStyle = {
    ...styles.container,
    minWidth: isMobile ? undefined : '400px',
  };

  const dynamicButtonContainerStyle = {
    ...styles.buttonContainer,
    justifyContent: centerAcceptButton ? 'center' : '',
  };

  return (
    <ModalView
      isLoading={isLoading}
      modalPath={modalPath}
      exitRoute={exitRoute}
      isOpen={isOpen}
      onClose={onClose}
      contentContainerStyle={contentContainerStyle}
      isMobile={isMobile}>
      <div style={dynamicContainerStyle}>
        <div style={styles.titleContainer}>
          {!!leftTitleIconName && <IconView name={leftTitleIconName} style={styles.titleIcon} />}
          {showTitle && <LabelView text={title} type={TEXT_TYPES.ITEM_HEADER} style={styles.title} />}
        </div>
        {message && <LabelView text={message} type={TEXT_TYPES.BODY} />}
        {children}
        {errorMessage && (
          <div style={{ marginTop: 4, marginLeft: 4 }}>
            <LabelView text={errorMessage} color={globalStyles.errorColor} />
          </div>
        )}
        <div style={dynamicButtonContainerStyle}>
          {!isAcceptHidden && (
            <div style={styles.confirmationButton}>
              <ButtonView
                customButtonBackgroundColor={customButtonBackgroundColor}
                disabled={isAcceptDisabled}
                text={confirmationButtonText}
                onClick={onAccept}
              />
            </div>
          )}
          <ButtonView
            withLinkStyle={true}
            text={secondaryButtonText}
            onClick={onSecondaryButton}
            style={styles.secondaryButton}
          />
        </div>
      </div>
    </ModalView>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
  },
  titleContainer: {
    display: 'flex',
  },
  titleIcon: {
    marginRight: '12px',
  },
  title: {
    paddingBottom: '24px',
    maxWidth: '95%',
  },
  buttonContainer: {
    paddingTop: '20px',
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  confirmationButton: {
    paddingLeft: '10px',
  },
  secondaryButton: {
    position: 'absolute',
    right: 0,
    top: 14,
    backgroundColor: 'transparent',
  },
};

export default withRouter(ConfirmationModalView);
